import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import { Palette as PaletteIcon, Check as CheckIcon } from '@mui/icons-material';
import { useAppTheme } from '../context/AppThemeContext';

const Swatch = ({ color }) => (
    <span
        style={{
            display: 'inline-block',
            width: 16,
            height: 16,
            borderRadius: '50%',
            backgroundColor: color,
            border: '1px solid rgba(0,0,0,0.15)',
        }}
    />
);

function ThemePicker() {
    const { themeId, setThemeId, themes } = useAppTheme();
    const [anchorEl, setAnchorEl] = useState(null);

    const handleSelect = (id) => {
        setThemeId(id);
        setAnchorEl(null);
    };

    return (
        <>
            <Tooltip title="Colour theme">
                <IconButton
                    onClick={(e) => setAnchorEl(e.currentTarget)}
                    aria-label="Choose colour theme"
                    sx={{ color: 'white' }}
                >
                    <PaletteIcon />
                </IconButton>
            </Tooltip>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
                {themes.map((t) => (
                    <MenuItem key={t.id} selected={t.id === themeId} onClick={() => handleSelect(t.id)}>
                        <ListItemIcon>
                            <Swatch color={t.primary} />
                        </ListItemIcon>
                        <ListItemText>{t.name}</ListItemText>
                        {t.id === themeId && (
                            <ListItemIcon sx={{ minWidth: 'auto', ml: 2 }}>
                                <CheckIcon fontSize="small" />
                            </ListItemIcon>
                        )}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}

export default ThemePicker;
